export var EventAction;
(function (EventAction) {
    EventAction["OpenModelTest"] = "OpenModelTest";
    EventAction["DisplayAnalysisInformation"] = "DisplayAnalysisInformation";
    EventAction["OpenAnalysisDetails"] = "OpenAnalysisDetails";
    EventAction["OpenFixIntent"] = "OpenFixIntent";
})(EventAction || (EventAction = {}));
